const translations = {
    es: {
        unload: "Recogida",
        unloads: "Recogidas",
        requiredTime: "Se tiene que seleccionar una hora.",
        unloadSuccess: "Se ha modificado correctamente",
        unloadError: "Error al modificar",
        filling: "Nivel %",
        hour: "Hora",
        date: "Fecha",
        level: "Nivel",
        day: "Día",
        close: "Cerrar",
    },
    en: {
        unload: "Collected",
        unloads: "Collected",
        requiredTime: "You have to select a time.",
        unloadSuccess: "Successfully modified",
        unloadError: "Error modifying",
        filling: "Filling %",
        hour: "Hour",
        date: "Date",
        level: "Level",
        day: "Day",
        close: "Close",
    },
};

export default translations;
